import { render, staticRenderFns } from "./SelectOptionalGoodsCard.vue?vue&type=template&id=28bfe1d4&scoped=true&"
import script from "./SelectOptionalGoodsCard.vue?vue&type=script&lang=js&"
export * from "./SelectOptionalGoodsCard.vue?vue&type=script&lang=js&"
import style0 from "./SelectOptionalGoodsCard.vue?vue&type=style&index=0&id=28bfe1d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bfe1d4",
  null
  
)

export default component.exports